export default __webpack_public_path__ + "static/media/0_Intro.7d5f27c1.mp4";